import React, { memo } from 'react';
import { motion } from 'framer-motion';
const features = [{
  title: 'Create Tattoos With AI',
  description: 'Start with a text idea or a photo and generate tattoo-ready designs in seconds. Our advanced AI understands tattoo styles, shading, and line work.',
  image: 'https://cdn.magicpatterns.com/uploads/pCcqNxNoR43teqYXbjCq8o/0x0ss_(38).png'
}, {
  title: 'Turn Photos Into Tattoo Art',
  description: 'Import any photo, pick a style, and transform it into a unique tattoo concept. Perfect for memorial pieces or turning memories into ink.',
  image: 'https://cdn.magicpatterns.com/uploads/vf5q9ZBygTn5Z4Z5JYxSKR/0x0ss_(39).png'
}, {
  title: 'Try It On Before You Ink',
  description: 'Use the AR camera to preview tattoo designs on your skin in real time. Adjust the size, placement, and angle to see exactly how it will look.',
  image: 'https://cdn.magicpatterns.com/uploads/mmWYhR9ZUpS7MxQWHjebWt/0x0ss_(40).png'
}, {
  title: 'Save Every Design You Love',
  description: 'Browse all your generated tattoos in one personal library. Organize your ideas, compare styles, and keep your inspiration ready for your artist.',
  image: 'https://cdn.magicpatterns.com/uploads/uwWzRLxy51c2CqVpdh4s1N/0x0ss_(41).png'
}, {
  title: 'Preview, Download, or Try It On',
  description: 'Open any design, save it in high resolution, or send it straight to the Try On camera. Getting your next tattoo has never been this seamless.',
  image: 'https://cdn.magicpatterns.com/uploads/uyaEaYpfNUYCqLbNvL3xsr/0x0ss_(42).png'
}];
export function Features() {
  return <section id="features" className="py-24 md:py-32 overflow-hidden" data-id="element-23">
      <div className="max-w-7xl mx-auto px-6" data-id="element-24">
        <div className="flex flex-col gap-32" data-id="element-25">
          {features.map((feature, index) => {
          const isEven = index % 2 === 0;
          return <div key={index} className={`flex flex-col ${isEven ? 'md:flex-row' : 'md:flex-row-reverse'} items-center gap-12 md:gap-24`} data-id="element-26">
                <motion.div initial={{
              opacity: 0,
              x: isEven ? -50 : 50
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true,
              margin: '-100px'
            }} transition={{
              duration: 0.6
            }} className="flex-1 text-center md:text-left" data-id="element-27">
                  <h2 className="text-4xl md:text-5xl font-black tracking-tighter mb-6 text-balance" data-id="element-28">
                    {feature.title}
                  </h2>
                  <p className="text-lg text-gray-400 text-balance leading-relaxed" data-id="element-29">
                    {feature.description}
                  </p>
                </motion.div>

                <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true,
              margin: '-100px'
            }} transition={{
              duration: 0.6,
              delay: 0.2
            }} className="flex-1 relative w-full max-w-[320px] md:max-w-[360px] mx-auto" data-id="element-30">
                  {/* Subtle blue glow halo */}
                  <div className="absolute inset-0 bg-tatan-blue/20 blur-[80px] rounded-full transform scale-90" data-id="element-31" />

                  <motion.div animate={{
                y: [0, -10, 0]
              }} transition={{
                repeat: Infinity,
                duration: 5 + index,
                ease: 'easeInOut'
              }} className="relative z-10" data-id="element-32">
                    <img src={feature.image} alt={feature.title} className="w-full drop-shadow-2xl rounded-[3rem] border-[6px] border-zinc-900/80" data-id="element-33" />
                  </motion.div>
                </motion.div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}